// @vue/component
import LayoutDefault from '@/layouts/LayoutClient.vue'
import { mapActions, mapGetters } from 'vuex'
import QList from '@/components/common/exhibitions/c-list.vue'
import TasksList from '@/components/common/tasks/c-list.vue'
import QListItem from '@/components/common/exhibitions/c-list-item.vue'
import dateTimeMixin from '@/mixins/datetime'
import colorsMixin from '@/mixins/colors'
import cssMixin from '@/mixins/css'
import DoctorProfile from '@/components/doctor/profile.vue'
import { Timer } from 'easytimer.js';
import vueFilePond from "vue-filepond";
import apiConfig from '@/static/apiConfig'
import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer/src/component.vue"
import moment from 'moment'

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageCrop from "filepond-plugin-image-crop";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import TokenService from '@/services/token.service'
import FilePondPluginImageEdit from "filepond-plugin-image-edit";
import "filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css";
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageFilter from 'filepond-plugin-image-filter';
import ApiService from '@/services/api.service'

import CropperEditor from 'cropperjs';

// Create component
const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginImageCrop,
    FilePondPluginImageResize,
    FilePondPluginImageTransform,
    FilePondPluginImageEdit,
    FilePondPluginImageExifOrientation,
    FilePondPluginImageFilter
);


export default {
    name: 'ContestUsers',


    components: {
        LayoutDefault,
        Viewer,
        FilePond,
        DoctorProfile,
        TasksList,
        QList,
        QListItem
    },

    mixins: [dateTimeMixin, colorsMixin, cssMixin],

    props: {
        contestId: {

        }
    },

    data () {
        return {
            rooms: [],
            myFiles: [],
            files: [],
            copied: false,
            filter: 'all',
            pageItems: [
                {
                    text: 'Конкурсы',
                    disabled: false,
                    exact:true,
                    to: {name: 'Contests'},
                }
            ],
            filterOptions: [
                {name: 'Все', value: 'all'},
                {name: 'Художники', value: 'painter'},
                {name: 'Пользователи', value: 'user'},
                {name: 'Профи', value: 'profi'},
                {name: 'Художники Г.С.', value: 'profi_gallery'},
                {name: 'Коллекционеры', value: 'collector'},
            ],
            headersTbl: [

                {
                    text: 'ФИО',
                    align: 'start',
                    filterable: true,
                    value: 'name',
                    width: 300
                },
                { text: 'Дата рождения', value: 'birthday', width: 160 },
                { text: 'Роль', value: 'role', width: 159 },
                { text: 'Статус', value: 'contest_status', width: 220 },
                { text: 'Город', value: 'city' },
                { text: 'Телефон', value: 'phone', align: 'end', },
                //{ text: 'Время регистрации', value: 'created_at', align: 'end', width: 200 },
                { text: 'Работ', value: 'actions', sortable: false, align: 'end', width: 80 },
                { text: '', value: 'data-table-expand', align: 'end', width: 50 },

            ],
            user: {},
            roles: [
                {value: 'user', text: 'Пользователь'},
                {value: 'painter', text: 'Художник'},
                {value: 'profi', text: 'Профи'},
                {value: 'profi_gallery', text: 'Художник Г.С.'},
                {value: 'collector', text: 'Коллекционер'},
            ],
            contestStatuses: [
                {value: 'none', text: 'Отклонен'},
                {value: 'participant', text: 'Участник'},
                {value: 'laureate', text: 'Лауреат'},
                {value: 'winner', text: 'Победитель'},
            ],
            currentDay: 1,
            search: '',
            sessionClock: '',
            filterFlow: 'noPinned',
            filterSection: 'users',
            filterTabs: 0,
            errorMessage: '',
            saving: false,
            dialogUser: false,
            validUserForm: false,
            viewer: null,
            tmpCode: null,
            waiting: false,
            loading: true,
            isCurrentUserAccepted: false,
            editingProfileId: false,
            sessionTimer: false,
            roomsLoaded: false,
            sessionActive: true,
            currentUserId: null,
            currentUser: null,
            timerStopwatch: null,
            editor: {

                // Called by FilePond to edit the image
                // - should open your image editor
                // - receives file object and image edit instructions
                open: (file, instructions) => {
                    // open editor here
                    console.log(file);
                },

                // Callback set by FilePond
                // - should be called by the editor when user confirms editing
                // - should receive output object, resulting edit information
                onconfirm: (output) => {},

                // Callback set by FilePond
                // - should be called by the editor when user cancels editing
                oncancel: () => {},

                // Callback set by FilePond
                // - should be called by the editor when user closes the editor
                onclose: () => {}
            },
            rules: {
                required: v => !!v || 'обязательное',
                min: v => v.length >= 6 || 'минимум 6 символов',
                email: v => /.+@.+\..+/.test(v) || 'E-mail введен неверно',
                passwordMatch: () => this.user.password === this.passwordConfirm || ('пароли не совпадают'),
            }
        }
    },

    computed: {
        ...mapGetters({
            getChatsList: 'chats/getChatsList',
            getUsersList: 'user/getUserList',
            getIsUserLoggedIn: 'auth/getIsUserLoggedIn',
            getErrors: 'user/getErrors',

            getUserData: 'auth/getUserData',
            getUserProfile: 'auth/getUserProfile',
        }),

        serverOptions: function() {
            return {
                process: {
                    url: apiConfig.url + '/file/save/user/0/' + this.tmpCode,
                    headers: {
                        Authorization: `Bearer ${TokenService.getToken()}`
                    }
                },
                //fetch: null,
                //revert: null
            }
        },


        maxDays: function() {
            let days = 0
            if (this.getUsersList && this.getUsersList.length) {
                let acceptUsers = this.getUsersList.filter(item => item.accepted)
                for (let i = 0; i < acceptUsers.length; i++) {
                    if (acceptUsers[i].duration > days) {
                        days = acceptUsers[i].duration
                    }
                }
            }
            return days
        },
        filteredUsers: function() {
          return this.getUsersList.filter(item => this.filter == 'all' || this.filter == item.role)

            /*return this.rooms.filter(item => this.currentUserId == item.dnet_id && (this.filter == 'closed' ? item.status == 'closed' : item.status != 'closed'))*/
        },


        openUsers: function() {
          return this.getUsersList.filter(item => true)
        },

        initials() {
            if (this.getUserData) {
                let names = this.getUserData.name.split(' ')
                return names[0].substring(0, 1) + (names.length > 1 ? names[1].substring(0, 1) : '')
            } else {
                return '—'
            }
        },

    },

    /*destroyed() {
        socket.off("connect_error");
        socket.off("private message");
    },*/

    watch: {
        async filter() {
            this.waiting = true
            await this.fetchUsersList({category: this.filter, contest_id: this.contestId})
            await setTimeout(() => {
                this.waiting = false
            }, 200)
        }
    },

    beforeDestroy() {
        this.clearTimeout()
    },


    async created () {
        //this.timerStopwatch = new Timer();
        this.pageItems.push(
            {
                text: '#' + this.contestId,
                disabled: false,
                exact:true,
                to: {name: 'ContestUsers', params: {contestId: this.contestId}},
            }
        );
        await this.fetchUsersList({contest_id: this.contestId})
        this.loading = false
        //await this.startSession(true)

        /*this.timerStopwatch.addEventListener('secondsUpdated',  (e) => {
            this.sessionClock = this.timerStopwatch.getTimeValues().toString()
            // $('#basicUsage').html(timer.getTimeValues().toString());
        });*/

        /*socket.auth = { username: this.getUserData.id };
        socket.connect();

        socket.on("private message", ({ content, from }) => {
            console.log('content on PM', content)
            this.$refs.chat.addMessageToChat(content.chat_id, content)
        });*/

        /*await this.fetchStats({
            own: true,
            period: 'all',
            begin: null,
            end: null,
        })*/
    },

    methods: {
        ...mapActions({
            fetchChatsList: 'chats/fetchChatsList',
            fetchUsersList: 'user/fetchUserList',
            clearErrors: 'user/clearErrors',
            changeStatus: 'user/changeStatus',
            changeContestStatus: 'user/changeContestStatus',
            changeRole: 'user/changeRole',
            saveUser: 'user/saveUser',
        }),

        copyText(img) {
            let text = ''
            if (img.height_cm && img.width_cm) {
                text += img.height_cm  + 'x' + img.width_cm + " см\n"
            }
            if (img.year) {
                text += img.year + " год\n"
            }
            if (img.title) {
                text += img.title + "\n"
            }
            if (img.description) {
                text += img.description + "\n"
            }
            this.$copyText(text)
            this.copied = true
        },

        changeUserContestStatus: async function(contestUserId, status) {

            this.saving = true
            try {
                this.clearErrors()
                await this.changeContestStatus({id: contestUserId, status: status})
                if (this.getErrors.length > 0) {
                    this.$root.$emit('error:show', this.getErrors[0])
                } else {
                    await this.fetchUsersList({})
                }
                this.saving = false
            } catch(e) {
                console.error(e)
                this.saving = false
            }
        },

        inited: function (viewer) {
            this.viewer = viewer
        },

        async downloadItem(item) {
            this.loading = true
            try {
                const response = await ApiService.post(apiConfig.url + '/contest/download', {user_id: item.item.user_id, contest_id: this.contestId}, { responseType: "blob" });
                const blob = new Blob([response.data], { type: "application/zip" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = item.item.last_name + ' ' +  item.item.first_name + ' - ' + moment().format('YYMMDD') + '.zip';
                link.click();
                URL.revokeObjectURL(link.href);
            } catch(e) {

            }
            this.loading = false
        },

        handleFilePondInit: function () {
            console.log("FilePond has initialized");

            // FilePond instance methods are available on `this.$refs.pond`
        },


        async messageBroadcast(content) {
            console.log('messageBroadcast', content)
            socket.emit("private message", {
                content,
                to: content.recipientId,
            });
        },

        async nextDayAndUpdate() {
            await this.nextDay()
            this.$router.go()
        },

        async onAnswered() {
            let room = this.rooms.find(r => r.id == this.currentChatId)
            if (room && room.status == 'preparing' || room.status == 'closed') {
                await this.loadRooms()
            }
        },

        async onUserSelected(data) {
            console.log('datadata', data)
            this.currentUserId = data.id;
            this.currentUser = data;
            this.isCurrentUserAccepted = data.accepted
        },

        async startSession(check) {
            let session = await this.checkSession(check)
            if (session.found) {
                this.sessionActive = session
                this.clearTimeout()
                this.timerStopwatch.start({
                    startValues: {
                        seconds: session.duration
                    }
                })
                this.sessionTimeout = setTimeout(() => {
                    this.startSession(true)
                }, session.left * 1000 + 1000)
            } else {
                this.clearTimeout()
                this.sessionActive = false
                this.sessionClock = ''
                this.timerStopwatch.reset()
                this.timerStopwatch.stop()
            }
        },

        async finishSessionConfirm() {
            await this.finishSession()
            this.clearTimeout()
            this.sessionActive = false
            this.sessionClock = ''
            this.timerStopwatch.reset()
            this.timerStopwatch.stop()
            await this.fetchStats({
                own: true,
                period: 'all',
                begin: null,
                end: null,
            })
        },

        clearTimeout() {
            if (this.sessionTimer) {
                clearTimeout(this.sessionTimer)
                this.sessionTimer = null
            }
        },

        async loadRooms() {
            await this.fetchChatsList({code: this.$route.params.code})
            const rooms = []
            for (let i = 0; i < this.getChatsList.length; i++) {
                rooms.push(this.getChatsList[i])
            }
            this.rooms = rooms
            this.roomsLoaded = true
        },

        deleteChatConfirm: async function(chatId) {
            const res = await this.$confirm('Delete this user?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.deleteChat(chatId)
                await this.loadRooms()

            }
        },

        closeChatConfirm: async function(chatId) {
            const res = await this.$confirm('Close this user?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.closeChat({chat_id: chatId})
                await this.loadRooms()

            }
        },



        refuseChatConfirm: async function(chatId) {
            const res = await this.$confirm('Refuse this user?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.refuseChat(chatId)

                if (this.getErrors.length > 0) {
                    this.$root.$emit('error:show', this.getErrors[0])
                } else {
                    await this.loadRooms()
                }





            }
        },

    }
}
